import z from 'zod';
import { songs } from '@/db/schema';
import { SONG_KEYS } from '@/lib/song/transpose';
import { queryParamsSchema } from '../core/schemas';

const songColumns = Object.keys(songs ?? {}) as [
  keyof typeof songs,
  ...(keyof typeof songs)[],
];

export const songSchemas = {
  queryParams: queryParamsSchema.extend({
    orderBy: z
      .enum(
        songColumns,
        'Campo inválido! Deve ser um dos seguintes: ' + songColumns.join(', '),
      )
      .optional(),
    id: z.string().optional(),
    title: z.string().optional(),
    artistId: z.string().optional(),
    originalKey: z.string().optional(),
    /** Raiz do tom (`C`, `F#`, `Bb`): casa o maior e o menor. */
    rootKey: z
      .string()
      .regex(/^[A-G][#b]?$/, 'Raiz do tom inválida!')
      .optional(),
    isActive: z.string().optional(),
    createdAt: z.coerce.date().optional(),
    createdAtFrom: z.coerce.date().optional(),
    createdAtTo: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    updatedAtFrom: z.coerce.date().optional(),
    updatedAtTo: z.coerce.date().optional(),
  }),
  create: z.object({
    title: z.string('Nome é obrigatório!').min(1, 'Campo obrigatório!'),
    originalKey: z.enum(SONG_KEYS, 'Tom original inválido!'),
    capo: z
      .number('Capo inválido!')
      .int('Capo inválido!')
      .min(0, 'Capo deve ser entre 0 e 12')
      .max(12, 'Capo deve ser entre 0 e 12')
      .nullish(),
    notes: z.string('Observações inválidas!').nullish(),
    content: z.string('Cifra é obrigatório!').min(1, 'Campo obrigatório!'),
    artistId: z.uuid('Artista inválido!').nullish(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional().default(true),
  }),
  update: z.object({
    title: z.string('Nome é obrigatório!').optional(),
    originalKey: z.enum(SONG_KEYS, 'Tom original inválido!').optional(),
    capo: z
      .number('Capo inválido!')
      .int('Capo inválido!')
      .min(0, 'Capo deve ser entre 0 e 12')
      .max(12, 'Capo deve ser entre 0 e 12')
      .nullish(),
    notes: z.string('Observações inválidas!').nullish(),
    content: z.string('Cifra é obrigatório!').optional(),
    artistId: z.uuid('Artista inválido!').nullish(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional(),
  }),
};

/** Filtros aceitos por `SongRepository.findAll` (os de `queryParams` sem paginação/ordem). */
export type SongListFilters = Partial<
  Pick<
    SongQueryParams,
    'id' | 'title' | 'artistId' | 'originalKey' | 'rootKey' | 'isActive' | 'search'
  >
>;

export type SongQueryParams = z.infer<typeof songSchemas.queryParams>;
export type CreateSongSchema = z.input<typeof songSchemas.create>;
export type UpdateSongSchema = z.infer<typeof songSchemas.update>;
